<template>
<div class='myPostIndex'>
    <el-tabs v-model="loginZt">
        <el-tab-pane label="管理员登录" name="company" v-loading="compLoading" element-loading-text="正在登录" element-loading-background="rgba(0, 0, 0, 0.8)">
            <el-input style="margin-top:30px" placeholder="请输入企业管理员账号" prefix-icon="el-icon-user" v-model="companyEmail">
            </el-input>
            <el-input type="password" style="margin-top:20px" placeholder="请输入企业管理员密码" prefix-icon="el-icon-key" v-model="companyPassword">
            </el-input>
            <el-button style="margin-top:20px" type="success" @click='goCompany'>登录</el-button>
        </el-tab-pane>
    </el-tabs>
</div>
</template>

<script>
import axios from 'axios'
import Config from '../config/index'
import {
    setInterval
} from 'timers';
export default {
    name: 'login',
    props: {},
    data() {
        return {
            loginZt: 'company',
            companyEmail: '',
            companyPassword: ''
        }
    },
    watch: {},
    created: function () {},
    methods: {
        goCompany: function () {
            let that = this
            if (that.companyEmail === '' || that.companyEmail === undefined) {
                that.$message.warning('请输入管理员账号')
                return false
            }
            if (that.companyPassword === '' || that.companyPassword === undefined) {
                that.$message.warning('请输入管理员密码')
                return false
            }
            this.compLoading = true
            let url = Config.path + '/api/platform/sysUser/logoin'
            axios({
                method: 'POST',
                url: url,
                headers: {
                    'Content-Type': 'application/json'
                },
                data: {
                    loginName: this.companyEmail,
                    password: this.companyPassword
                }
            }).then(function (response) {
                console.log(response)
                if (response.data.success === '1') {
                    localStorage.setItem('token',response.data.content.sysToken)
                    localStorage.setItem('name',response.data.content.name)
                    localStorage.setItem('phone',response.data.content.phone)
                    localStorage.setItem('status',response.data.content.status)
                    localStorage.setItem('wechart',response.data.content.wechart)
                    that.$notify({
                        title: '提示',
                        message: '登录成功',
                        type: 'success',
                        duration: 1000
                    });
                    that.$router.push({
                        path: '/'
                    })
                    that.compLoading = false
                } else {
                    that.compLoading = false
                    that.$message({
                        message: response.data.message,
                        type: 'warning'
                    });
                }
            }).catch(function (error) {
                that.loading = false

                // eslint-disable-next-line
                console.log(error)
            })
        }
    },
    mounted: function () {
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndex {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;


    .el-tab-pane {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .el-tabs__item {
        color: #ffffff;
    }
 
}
</style>
